<template>
  <v-row>
    <v-col>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :search="search"
        :hide-default-footer="hideFooter"
        v-model="selected"
        multi-sort
        show-select
      >
        <template #item.date="{ item }">{{ item.date | formatDate }}</template>
        <template #item.releaseDate="{ item }">{{
          item.releaseDate | formatDate
        }}</template>
        <template #item.actions="{ item }">
          <default-list-actions
            :item="item"
            :hide-view="false"
            @deleteItem="deleteItem"
            @editItem="editItem"
            @viewItem="onViewItem"
            :hide-remove="$store.getters.hasAccessTo('suppliers:view_only')"
            :hide-edit="$store.getters.hasAccessTo('suppliers:view_only')"
          ></default-list-actions>
        </template>
        <template v-slot:footer>
          <simple-list-actions
            v-if="selected.length > 0"
            @delete="onDelete"
            :hide-delete="$store.getters.hasAccessTo('suppliers:view_only')"
          >
            <v-btn
              fab
              dark
              small
              color="blue-grey darken-1"
              @click="onEditMulti"
              v-if="!$store.getters.hasAccessTo('suppliers:view_only')"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-pencil</v-icon>
                </template>
                Edit Records
              </v-tooltip>
            </v-btn>
          </simple-list-actions>
        </template>
      </v-data-table>
      <allocation-usage-dialog
        :show="showDetails"
        @close="showDetails = false"
        v-model="selectedItem"
      ></allocation-usage-dialog>
    </v-col>
  </v-row>
</template>

<script>
import DefaultListActions from "../../shared/DefaultListActions";
import SimpleListActions from "../../shared/list-actions/SimpleListActions";
import AllocationUsageDialog from "./AllocationUsageDetailsDialog";
export default {
  name: "allocations-table",
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    search: {
      type: String,
      default: () => "",
    },
    hideFooter: {
      type: Boolean,
      default: () => false,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },

  components: { DefaultListActions, SimpleListActions, AllocationUsageDialog },

  data() {
    return {
      selected: [],
      showDetails: false,
      selectedItem: null,
    };
  },

  methods: {
    onEditMulti() {
      this.$emit("edit-mutlti", [...this.selected]);
      this.selected = [];
    },
    onViewItem(payload) {
      this.showDetails = true;
      this.selectedItem = { ...payload };
    },
    deleteItem(payload) {
      this.$emit("delete", payload);
    },
    editItem(payload) {
      this.$emit("edit", payload);
    },
    onDelete() {
      this.$emit("deleteRecords", [...this.selected]);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/allocations/AllocationsTable.vue